module.exports = __webpack_public_path__ + "img/top.bef89b7b.webp";